var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.metaModule.showQrisManagementMenu)?_c('div',[_c('router-view',{attrs:{"name":"dialog"}}),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }